import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

// RecreationalRuns (Motionsløb) business information schema
// Fields inferred from Figma node 1678:31171
export const RECREATIONAL_RUNS_CONTENT_PATH = 'licenses.steps.businessInformation.forms.recreationalRuns';

export const recreationalRunsSchema = BasicBusinessInformationSchema.extend({
  raceName: z.string().min(1, { message: `${RECREATIONAL_RUNS_CONTENT_PATH}.raceName.validation.required` }),
  date: z
    .string()
    .min(1, { message: `${RECREATIONAL_RUNS_CONTENT_PATH}.date.validation.required` })
    .regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: `${RECREATIONAL_RUNS_CONTENT_PATH}.date.validation.validFormat`,
    }),
  participantCount: z
    .number({
      required_error: `${RECREATIONAL_RUNS_CONTENT_PATH}.participantCount.validation.required`,
    })
    .int({ message: `${RECREATIONAL_RUNS_CONTENT_PATH}.participantCount.validation.required` })
    .min(1, { message: `${RECREATIONAL_RUNS_CONTENT_PATH}.participantCount.validation.required` }),
});

export type RecreationalRunsForm = z.infer<typeof recreationalRunsSchema>;

export const createRecreationalRunsDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.RecreationalRuns,
  raceName: '',
  date: '',
});

export const toPayloadRecreationalRuns = (form: RecreationalRunsForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.date).format('YYYY-MM-DD'),
    quantity: form.participantCount ?? 0,
  };
};
